import { useState } from 'react';
import { Dialog } from '@mui/material';
import { useSafeNavigation } from '../hooks/useSafeNavigation';

type ModalRouteProps = {
  children: JSX.Element;
};
export const ModalRoute = ({ children }: ModalRouteProps) => {
  const [isOpen, setIsOpen] = useState(true);
  const { safeNavigate } = useSafeNavigation();
  const handleClose = () => {
    setIsOpen(false);
    safeNavigate(-1);
  };
  return (
    <Dialog open={isOpen} onClose={handleClose} aria-labelledby="modal-title" aria-describedby="modal-description">
      {children}
    </Dialog>
  );
};
